<template>
  <div class="promoTileContainer" v-if="promoTiles && promoTiles.length > 0">
    <Carousel
      :autoplay="true"
      :per-page="1"
      :autoplayTimeout="5000"
      :mouse-drag="false"
      :paginationEnabled="true"
      :navigationEnabled="false"
      :loop="true"
    >
      <Slide v-for="(tile, index) in promoTiles" :key="index">
        <a v-if="tile.url" :href="tile.url">
          <img :src="tile.image" :height="tile.height + 'px'">
        </a>
        <img v-else :src="tile.image" :height="tile.height + 'px'">
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { fetchPromoTile } from "@/network/wordpressRequests";

import { Slide, Carousel } from "vue-carousel";
// import Carousel from '../carousel/Carousel'

export default {
  name: "PromoTile",
  props: ["name"],
  components: {
    Slide,
    Carousel
  },
  data() {
    return {
      promoTilesData: []
    };
  },
  created() {
    fetchPromoTile({ slug: this.name }, response => {
      this.promoTilesData = response;
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize')) //makes sure first image shows up in slider
      })
    });
  },
  computed: {
    promoTiles() {
      let memberLevel = this.$store.state.auth.memberLevel;
      //filter promo tiles to only show correct ones for member level
      let filtered = this.promoTilesData.filter(item => {
        if(item.acf.visible_to_members.includes(memberLevel)){
          return true;
        }
        return false;
      })

      return filtered.map(item => {
        return {
          url: item.acf.link,
          image: item.acf.tile.sizes["ct-large"],
          height: item.acf.tile.sizes["ct-large-height"]
        };
      });
    }
  },
  watch:{
    promoTiles(){
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize')) //makes sure first image shows up in slider
      })
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
  height: auto;
}

.VueCarousel-slide {
  text-align: center;
}

.VueCarousel::v-deep {
    position:relative;
    padding-bottom:15px;
  .VueCarousel-pagination {
    z-index: 1;
    position:absolute;
    bottom:-15px;
    // margin-top: -20px;

    .VueCarousel-dot-container {
      margin-top: 0 !important;
    }
  }
}
</style>
